export default {
  bigHouse: '¿La propiedad es más de 6,000 pies cuadrados?'
};
